// src/services/firebaseConfig.js

// MODIFICADO: Importado 'getApps' e 'getApp' para evitar a reinicialização.
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Sua configuração do Firebase permanece aqui.
const firebaseConfig = {
    apiKey: "AIzaSyDwgokJ342kxknQlFeOmlLwSI14WsdiDnI",
    authDomain: "portal-sisfol.firebaseapp.com",
    projectId: "portal-sisfol",
    storageBucket: "portal-sisfol.appspot.com",
    messagingSenderId: "693463369463",
    appId: "1:693463369463:web:cc5025a2018494336af5f2",
    measurementId: "G-Z42ZWVLREM"
};
 
// MODIFICADO: Lógica para garantir que o Firebase seja inicializado apenas uma vez.
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const firestorePathId = 'sisfol-rh-online';
